// extracted by mini-css-extract-plugin
module.exports = {"hexagonWrapper":"styles_hexagonWrapper__1Msve","hexagon":"styles_hexagon__3NgT9","hexagonContent":"styles_hexagonContent__10aDM"};